import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { BASE_URL } from "../env";
import ComingSoon from "./coming soon";

const Hybridexamsbybatches2 = () => {
	const { batch } = useParams();
	const [allassignments, setallAssignments] = useState([]);

	const [selectedassignments, setSelectedAssignments] = useState([]);

	function CheckValueExistInArrayorNot(array, value) {
		for (var i = 0; i < array.length; i++) {
			if (array[i] === value) {
				return true;
			}
		}
		return false;
	}

	function RemoveValuefromarray(array, value) {
		return array;
	}

	function AddorremovevaluetoArray(array, value) {
		if (CheckValueExistInArrayorNot(array, value)) {
			for (var i = 0; i < array.length; i++) {
				if (array[i] === value) {
					array.splice(i, 1);
				}
			}
		} else {
			array.push(value);
		}
		return array;
	}
	useEffect(() => {
		let batcharray = [batch];
		fetch(BASE_URL + "/gethybridexamsbybatch/" + batch, {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
			},
		})
			.then((res) => res.json())
			.then((data) => {
				console.log(data);
				setallAssignments(data);
			});
	}, []);

	useEffect(() => {
		console.log(selectedassignments);
	}, [selectedassignments]);
	return (
		<div>
			<h1>
				Select the assignments that you want to see the results from
			</h1>
			{allassignments.map((data) => {
				return (
					<>
						<div
							style={{
								background: CheckValueExistInArrayorNot(
									selectedassignments,
									data._id
								)
									? "#ff3"
									: "#ffffff",
							}}
							onClick={() => {
								if (
									!CheckValueExistInArrayorNot(
										selectedassignments,
										data._id
									)
								) {
									let array = [...selectedassignments];
									array.push(data._id);
									setSelectedAssignments(array);
								} else {
									let array = selectedassignments.filter(
										(dta) => dta !== data._id
									);
									setSelectedAssignments(array);
								}
								// setSelectedAssignments(array);
							}}
						>
							<h1>{data?.nameoftheExam}</h1>
							<p>{data?.courseId?.name} </p>
						</div>
					</>
				);
			})}

			<Link
				to={{
					pathname: "/alltableresultsbyassignments",
					state: selectedassignments,
				}}
			>
				{" "}
				<button className="btn btn-lg btn-primary">Next</button>{" "}
			</Link>
		</div>
	);
};

export default Hybridexamsbybatches2;
